export const convertMinutesToHours = (minutes) => {
  return minutes / 60;
};
